export const Marquee = ({ items, dark = true }) => {
  const row = [...items, ...items, ...items];
  return (
    <div
      data-testid="marquee"
      className={`overflow-hidden border-y py-4 ${
        dark ? "border-stone-800 bg-[#121110] text-stone-300" : "border-[#E5E0D8] bg-[#FAF6F0] text-stone-600"
      }`}
    >
      <div className="marquee-track gap-0">
        {[0, 1].map((half) => (
          <div key={half} className="flex shrink-0 items-center">
            {row.map((item, i) => (
              <span key={`${half}-${i}`} className="flex items-center whitespace-nowrap">
                <span className="font-display text-lg italic tracking-wide">{item}</span>
                <span className="mx-6 text-red-500">✳</span>
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};
